export function convertLineBreak(fileJson) {
    fileJson.introduction.parts = fileJson.introduction.text.split("\n");
    for (let i = 0; i < fileJson.chapters.length; i++) {
        fileJson.chapters[i].parts = fileJson.chapters[i].text.split("\n");
    }
    return fileJson;
}